import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Navigation() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-50">
      <div className="container-max px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate('/')}
          >
            <img src="/logo/LG.png" alt="Carkey Solutions" className="h-10 w-auto mr-3" />
            <div className="text-2xl font-bold text-gray-900">
              <span className="text-carkey-red">Car</span>key Solutions
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => navigate('/')} className="text-gray-700 hover:text-carkey-red transition-colors">Home</button>
            <button onClick={() => navigate('/manufacturers')} className="text-gray-700 hover:text-carkey-red transition-colors">Services</button>
            <button onClick={() => navigate('/quote')} className="text-gray-700 hover:text-carkey-red transition-colors">Get Quote</button>
                          <a href="tel:+61430168669" className="flex items-center space-x-2 text-gray-700 hover:text-carkey-red transition-colors">
              <i className="fas fa-phone"></i>
              <span>Call Us</span>
            </a>
                          <a href="https://wa.me/61430168669" className="flex items-center space-x-2 text-gray-700 hover:text-carkey-red transition-colors">
              <i className="fab fa-whatsapp"></i>
              <span>Message Us</span>
            </a>
          </nav>

          {/* Quick Access Icons & CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <button onClick={() => navigate('/quote')} className="bg-carkey-red text-white px-6 py-2 rounded-xl font-semibold hover:bg-red-600 transition-colors">
              Get a Quote
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-gray-700 hover:text-carkey-red transition-colors"
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-4 space-y-4">
              <button onClick={() => navigate('/')} className="block w-full text-left text-gray-700 hover:text-carkey-red transition-colors">Home</button>
              <button onClick={() => navigate('/manufacturers')} className="block w-full text-left text-gray-700 hover:text-carkey-red transition-colors">Services</button>
              <button onClick={() => navigate('/quote')} className="block w-full text-left text-gray-700 hover:text-carkey-red transition-colors">Get Quote</button>
              <div className="pt-4 border-t border-gray-200">
                                  <a href="tel:+61430168669" className="flex items-center space-x-2 text-gray-700 hover:text-carkey-red transition-colors mb-3">
                  <i className="fas fa-phone"></i>
                  <span>Call Us</span>
                </a>
                                  <a href="https://wa.me/61430168669" className="flex items-center space-x-2 text-gray-700 hover:text-carkey-red transition-colors mb-3">
                  <i className="fab fa-whatsapp"></i>
                  <span>Message Us</span>
                </a>
              </div>
              <button onClick={() => navigate('/quote')} className="bg-carkey-red text-white px-6 py-2 rounded-xl font-semibold hover:bg-red-600 transition-colors w-full">
                Get a Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Navigation;
